export const getUrl = (url) => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const fullUrl = `${baseUrl}${url}`.replace(/\\/g, "/"); // Replace \ with /
  console.log(fullUrl);
  return fullUrl;
};

export const getAbsoluteUrl = (url) => {
  console.log(url);
  // Normalize input and guard against non-string values
  if (typeof url !== "string") return "";
  const cleanUrl = url.trim().replace(/\\/g, "/");
  console.log(cleanUrl);
  if (!cleanUrl) return "";
  const isAbsolute = /^https?:\/\//i.test(cleanUrl);
  if (isAbsolute) return cleanUrl;
  // ensure single slash between base and path
  const base = (process.env.REACT_APP_BASE_URL || "").trim();
  if (!base) return cleanUrl; // fallback to relative if base not set
  const needsSlash = !base.endsWith("/") && !cleanUrl.startsWith("/");
  const returnUrl = needsSlash ? `${base}/${cleanUrl}` : `${base}${cleanUrl}`;
  console.log(returnUrl);
  return returnUrl;
};
